import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export const TitleAnnouncer = (): JSX.Element => {
  const [title, setTitle] = useState('');
  const titleRef = useRef<HTMLParagraphElement>(null);
  const { pathname } = useLocation();

  const onHelmetChange = ({ title: updatedTitle }: { title: string }) => setTitle(updatedTitle);

  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, [pathname]);

  return (
    <>
      <p tabIndex={-1} ref={titleRef} className="sr-only">
        {title}
      </p>

      <Helmet onChangeClientState={onHelmetChange} />
    </>
  );
};
